import React from "react";
import { MENLO_PARK_LICENSES } from "@bto/shared";
import { GetTypographyContent } from "../shared/Typography/Typography";

export const FooterAcreditationInfoBottom = (): React.ReactElement => (
  <>
    {GetTypographyContent({
      content: "ACCREDITATIONS MENLO PARK:",
      size: "small",
    })}
    {MENLO_PARK_LICENSES.map((license, index) => (
      <React.Fragment key={license.content}>
        {index > 0 &&
          GetTypographyContent({
            content: "•",
            size: "small",
          })}
        {license.link
          ? GetTypographyContent({
              content: license.content,
              size: "small",
              link: license.link,
              externalLink: true,
              textColor: "greenDark",
            })
          : GetTypographyContent({
              content: license.content,
              size: "small",
            })}
      </React.Fragment>
    ))}
  </>
);
